import React, { createContext, useContext, useEffect, useState } from 'react';
import ApiService from 'services/ApiService';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';
import styles from 'pages/css/rdTrf.module.css';

const TrafficTotalContext = createContext(null);

export function SwItsParkingCntTotalProvider({ children }) {
    const [currentData, setCurrentData] = useState();

    useEffect(() => {
        return repeatEffect(async () => {
            const response = await ApiService.get("newdashboard/roadtraffic/GetParking");
            if (response.status === 200) {
                const data = response.data;

                setCurrentData({
                    updateTime: data.updateTime,
                    parkingCount: data.parkingCount,
                    totalCellSum: data.totalCellSum,
                    remainCellSum: data.remainCellSum,
                    lvCount: data.lvCount
                });
            }
        }, settingsConfig().contentUpdateDelaySec);
    }, []);

    return (
        <TrafficTotalContext.Provider value={currentData}>
            {children}
        </TrafficTotalContext.Provider>
    );
}





export function SwItsParkingCntTotalInfo() {
    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;

    const levelLabelMap = {
        1: '여유',
        2: '보통',
        3: '혼잡',
        4: '매우 혼잡',
        //5: '만차',
    };

    const categoryColor = {
        '여유': styles.relaxed,
        '보통': styles.normal,
        '혼잡': styles.busy,
        '매우 혼잡': styles.veryBusy,
        '만차': styles.full,
        '현장 운영': styles.operating
    };

    // 기본값 0으로 세팅
    const defaultStatusList = Object.entries(levelLabelMap).map(([lv, label]) => ({
        lv: Number(lv),
        label,
        count: 0
    }));

    currentData.lvCount.forEach(item => {
        const target = defaultStatusList.find(status => status.lv === item.lv);
        if (target) {
            target.count = item.count;
        }
    });

    // const parkingStatusList = currentData.lvCount.map(item => ({
    //     label: levelLabelMap[item.lv],
    //     count: item.count
    // }));

    return (
        <>
            <div className={`${styles.parkingConts_rd} L_lr`}>
                <div className={`${styles.parkingContsLeft_rd} L_2m_20 L_tb`}>
                    <div className='L_d_i flx flx_col a_center j_center innerBg'>
                        <p className='subTit'>공영주차장 총개소</p>
                        <div className='flx a_flx_end j_center'>
                            <span className='nbr' style={{ color: 'var(--alert-50)' }}>{currentData.parkingCount.toLocaleString()}</span>&nbsp;
                            <span className='subTxt' style={{ marginBottom: '14px' }}>개소</span>
                        </div>
                    </div>
                    <div className={`${styles.flx_1} ${styles.gap_20} L_d_i L_lr`}>
                        <div className={`${styles.flx_1} L_2m_20 innerBg flx flx_col a_center j_center`}>
                            <p className='subTit'>총 주차 면수</p>
                            <div className='flx a_flx_end j_center'>
                                <span className='nbr'>{currentData.totalCellSum.toLocaleString()}</span>&nbsp;
                                <span className='subTxt' style={{ marginBottom: '14px' }}>개</span>
                            </div>
                        </div>
                        <div className={`${styles.flx_1} L_2m_20 innerBg flx flx_col a_center j_center`}>
                            <p className='subTit'>주차 가능 면수</p>
                            <div className='flx a_flx_end j_center'>
                                <span className='nbr'>{currentData.remainCellSum.toLocaleString()}</span>&nbsp;
                                <span className='subTxt' style={{ marginBottom: '14px' }}>개</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.parkingListWrap} L_2m_20 flx flx_col a_center j_spc_btw`}>
                    {defaultStatusList.map((item, idx) => (
                        <div key={idx} className={`${styles.parkingList} innerBg flx a_center j_spc_btw`}>
                            <p className='subTit'>{item.label}</p>
                            <div className='flx a_flx_end'>
                                <span className={`nbr ${categoryColor[item.label]}`}>{item.count.toLocaleString()}</span>
                                <span className='subTxt'>개소</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
